/**
 * Feature Flags für Meta Quest 3 Integration
 * 
 * Zum Deaktivieren aller Quest-Features: QUEST_FEATURES.enabled = false
 * Einzelne Features können separat ein/ausgeschaltet werden
 */

const QUEST_FEATURES = {
  // Master Switch - schaltet alle Quest-Features aus
  enabled: true, // 🟢 AKTIVIERT für Quest-Entwicklung
  
  // Video-Stream für kontinuierliches Scannen
  videoMode: {
    enabled: true,
    continuousOCR: false,          // 🔴 DEAKTIVIERT - zu viele Fehlerkennungen bei schwarzem Bild
    ocrInterval: 500,              // ms zwischen OCR-Scans (nicht verwendet wenn disabled)
    videoFPS: 30,                  // Target FPS für flüssiges Video (nicht Browser-limitiert)
  },
  
  // ChatGPT Vision API Integration
  visionAPI: {
    enabled: true,                  // ✅ Firebase Function ist deployed!
    provider: 'openai',            // 'openai' oder 'google'
    model: 'gpt-4o-mini',          // gpt-4o-mini für günstige Analyse
    maxTokens: 500,
    temperature: 0.1,              // Niedrig für präzise Extraktion
    // VPS Vision API Route (ersetzt Firebase Cloud Function):
    apiUrl: 'VPS',  // Wird nicht mehr direkt als URL genutzt — siehe visionService.js
  },
  
  // Hands-free Trigger
  triggers: {
    doubleBlink: {
      enabled: false,              // 🔴 Noch nicht implementiert
      timeWindow: 800,             // ms zwischen Blinks
    },
    voiceCommand: {
      enabled: false,              // 🔴 DEAKTIVIERT - funktioniert noch nicht richtig
      commands: ['scan', 'scannen', 'speichern', 'abbrechen'],
      language: 'de-DE',
    },
    autoTimer: {
      enabled: false,              // 🔴 DEAKTIVIERT - braucht OCR
      stabilityDuration: 3000,     // 3s stabile Erkennung = Auto-Trigger
    },
    manualButton: {
      enabled: true,               // ✅ Manueller Scan-Button (primär)
      size: 'large',               // large/medium/small
    }
  },
  
  // UI Anpassungen
  ui: {
    showLiveChronik: true,         // Live-Liste eingelagerter Pakete
    showHausnummerReminder: true,  // "Hausnummer aufschreiben!" Erinnerung
    simplifiedLayout: true,        // Nur Eingang, keine Ausgabe
    hapticFeedback: true,          // Vibration bei Actions
  },
  
  // Live-Suche: Quest → Tablet Sync (Tablet-Suche auf Handy anzeigen)
  LIVE_SEARCH_ENABLED: true,       // ✅ AKTIVIERT - Kundentablet → Hauptgerät
  
  // Entwicklung & Debugging
  debug: {
    enabled: true,                 // 🔴 Immer aktiviert für Quest-Entwicklung
    showConfidence: true,          // Confidence-Scores anzeigen
    logVisionAPI: true,            // API Calls loggen
    showDeviceSwitcher: true,      // Manual device mode switcher
  }
};

export default QUEST_FEATURES;
